var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGateChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#D35756"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1225_1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5945 8.18017L12.9693 10.0854V12.2944L14.2161 11.6307V12.9118L10.7028 14.9405L7.87934 13.3097C7.6695 13.1885 7.49526 13.0143 7.37414 12.8044C7.25303 12.5946 7.1893 12.3565 7.18937 12.1142V8.85402L10.1034 7.17148C10.2856 7.06628 10.4922 7.0109 10.7026 7.0109C10.913 7.0109 11.1197 7.06628 11.3019 7.17148L14.2159 8.85402L15.9997 7.82396L11.4601 5.20278C11.2296 5.06993 10.9683 5 10.7022 5C10.4362 5 10.1749 5.06993 9.94438 5.20278L5.40552 7.8243V13.1421C5.40553 13.3851 5.4695 13.6239 5.591 13.8344C5.7125 14.0449 5.88726 14.2197 6.09772 14.3413L10.703 17.0001L15.3017 14.3452C15.5141 14.2226 15.6905 14.0462 15.8131 13.8338C15.9358 13.6213 16.0003 13.3804 16.0002 13.1351V10.6817L16.5942 10.366V8.18017H16.5945Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1225_1665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateChain);
export default __webpack_public_path__ + "static/media/GateChain.bdfa06476ca5e2e5766449ac00a8f230.svg";
export { ForwardRef as ReactComponent };